import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MasterTable from "../common/MasterTable";
import { axiosPostApi, axiosGetApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import {
  BsCheckCircleFill,
  BsSendFill,
  BsClockHistory,
  BsWifiOff,
  BsXCircleFill,
  BsExclamationTriangleFill,
} from "react-icons/bs";
import CustomAlert from "../../helpers/CustomAlert";
import { toast } from "react-toastify";
import Loader from "../Loader/Loader";
import BulkMessageModal from "../bulkMessage/bulkMessageModal";
import BulkFilterModal from "./BulkFilterModal";
import Swal from "sweetalert2";
import useExcelDownloader from "../../Hooks/useExcelDownloader";
import { format, parse } from "date-fns";
import { formatDateToYYYYMMDD, getLast7DaysRange } from "../../helpers/DateHelpers";
import { useDispatch } from "react-redux";
import { setBalance } from "../store/balance/balanceSlice";

const defaultFilterData = {
  sendorId: "",
  templateId: "",
  status: [],
  // fromDate: "",
  // toDate: "",
  ...getLast7DaysRange(),
};

const STAT_CONFIG = [
  {
    key: "DELIVERED",
    label: "Delivered",
    color: "#0ca30c",
    bg: "#EAF7EA",
    Icon: BsCheckCircleFill,
  },
  {
    key: "SEND",
    label: "Sent",
    color: "#2f80c4",
    bg: "#EAF3FB",
    Icon: BsSendFill,
  },
  {
    key: "PENDING",
    label: "Pending",
    color: "#c98a00",
    bg: "#FFF6E5",
    Icon: BsClockHistory,
  },
  {
    key: "NOT REACHABLE",
    label: "Not Reachable",
    color: "#e0703e",
    bg: "#FDEEE8",
    Icon: BsWifiOff,
  },
  {
    key: "FAILED",
    label: "Failed",
    color: "#d03b3b",
    bg: "#FBEAEA",
    Icon: BsXCircleFill,
  },
  {
    key: "EXCEPTION",
    label: "Exception",
    color: "#8b5cf6",
    bg: "#F2EDFC",
    Icon: BsExclamationTriangleFill,
  },
];

const StatsModal = ({ show, handleClose, loading, stats, errorMessage, bulkFileId }) => {
  const navigate = useNavigate();

  if (!show) return null;

  const handleFailedClick = () => {
    navigate(`/smstransaction?status=FAILED&bulkFileId=${bulkFileId}`);
  };

  const total = STAT_CONFIG.reduce(
    (sum, { key }) => sum + (Number(stats?.[key]) || 0),
    0
  );
  const delivered = Number(stats?.DELIVERED) || 0;
  const deliveryRate = total > 0 ? ((delivered / total) * 100).toFixed(1) : "0.0";
  const hasStats = !!stats && total > 0;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1031,
      }}
    >
      <style>
        {`
          @keyframes statsSpin {
            to { transform: rotate(360deg); }
          }
        `}
      </style>
      <div
        style={{
          width: "520px",
          maxWidth: "92vw",
          borderRadius: "24px",
          padding: "24px",
          backgroundColor: "#FFF",
          border: "1px solid rgba(0, 0, 0, 0.175)",
          position: "relative",
          boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "linear-gradient(90deg,#F8FAFF,#EEF5FF)",
            borderRadius: "18px",
            padding: "18px 24px",
            borderBottom: "1px solid #E8EDF5",
            marginBottom: "20px",
          }}
        >
          <h5 style={{ margin: 0, fontSize: "18px", fontWeight: "bold", color: "#1A1A1A" }}>
            Campaign Statistics
          </h5>
          <span
            onClick={handleClose}
            style={{
              cursor: "pointer",
              color: "#777",
              fontSize: "24px",
              fontWeight: "bold",
              lineHeight: "1",
            }}
          >
            &times;
          </span>
        </div>

        {loading ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "40px 24px",
              gap: "12px",
            }}
          >
            <div
              style={{
                width: "28px",
                height: "28px",
                borderRadius: "50%",
                border: "3px solid #E8EDF5",
                borderTopColor: "#00B6CE",
                animation: "statsSpin 0.8s linear infinite",
              }}
            />
            <span style={{ fontSize: "14px", color: "#6D6D6D" }}>
              Loading statistics...
            </span>
          </div>
        ) : errorMessage ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              padding: "40px 24px",
              textAlign: "center",
            }}
          >
            <BsExclamationTriangleFill style={{ color: "#c98a00", width: "28px", height: "28px" }} />
            <span style={{ fontSize: "14px", color: "#6D6D6D" }}>{errorMessage}</span>
          </div>
        ) : !hasStats ? (
          <div
            style={{
              padding: "40px 24px",
              fontSize: "14px",
              color: "#6D6D6D",
              textAlign: "center",
            }}
          >
            No statistics available for this campaign.
          </div>
        ) : (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "0 4px 18px",
              }}
            >
              <div>
                <div style={{ fontSize: "12px", color: "#898781", fontWeight: 600, letterSpacing: "0.02em" }}>
                  TOTAL MESSAGES
                </div>
                <div style={{ fontSize: "22px", color: "#1A1A1A", fontWeight: "bold" }}>
                  {total.toLocaleString()}
                </div>
              </div>
              <div style={{ textAlign: "right" }}>
                <div style={{ fontSize: "12px", color: "#898781", fontWeight: 600, letterSpacing: "0.02em" }}>
                  DELIVERY RATE
                </div>
                <div style={{ fontSize: "22px", color: "#0ca30c", fontWeight: "bold" }}>
                  {deliveryRate}%
                </div>
              </div>
            </div>

            <div
              style={{
                height: "8px",
                borderRadius: "4px",
                backgroundColor: "#F0F0EE",
                overflow: "hidden",
                marginBottom: "20px",
              }}
            >
              <div
                style={{
                  height: "100%",
                  width: `${deliveryRate}%`,
                  borderRadius: "4px",
                  backgroundColor: "#0ca30c",
                  transition: "width 0.4s ease",
                }}
              />
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "12px",
              }}
            >
              {STAT_CONFIG.map(({ key, label, color, bg, Icon }) => {
                const isFailed = key === "FAILED";
                return (
                  <div
                    key={key}
                    onClick={isFailed ? handleFailedClick : undefined}
                    role={isFailed ? "button" : undefined}
                    tabIndex={isFailed ? 0 : undefined}
                    onKeyDown={
                      isFailed
                        ? (e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              e.preventDefault();
                              handleFailedClick();
                            }
                          }
                        : undefined
                    }
                    title={isFailed ? "View failed messages" : undefined}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      padding: "12px 14px",
                      borderRadius: "14px",
                      backgroundColor: bg,
                      cursor: isFailed ? "pointer" : "default",
                      border: isFailed ? `1px solid ${color}33` : "1px solid transparent",
                      transition: "box-shadow 0.15s ease, transform 0.15s ease",
                    }}
                  >
                    <div
                      style={{
                        width: "36px",
                        height: "36px",
                        minWidth: "36px",
                        borderRadius: "50%",
                        backgroundColor: "#FFF",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Icon style={{ color, width: "18px", height: "18px" }} />
                    </div>
                    <div style={{ overflow: "hidden", flex: 1 }}>
                      <div style={{ fontSize: "18px", fontWeight: "bold", color: "#1A1A1A", lineHeight: 1.2 }}>
                        {(Number(stats?.[key]) || 0).toLocaleString()}
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          color: "#6D6D6D",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {label}
                      </div>
                    </div>
                    {isFailed && (
                      <span style={{ color, fontSize: "16px", fontWeight: "bold" }}>
                        &rsaquo;
                      </span>
                    )}
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

const BulkReport = () => {
  const pageSize = 10;
  const loggedInUserName = sessionStorage.getItem("username");
  const { downloadExcel } = useExcelDownloader();
  const dispatch = useDispatch();

  const [noData, setNoData] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [modalAction, setModalAction] = useState("");
  const [loading, setLoading] = useState(true);
  const [smsData, setSmsData] = useState([]);
  const [pageDetails, setPageDetails] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowData, setRowData] = useState(null);
  const [filterData, setFilterData] = useState(defaultFilterData);
  const [isModalOpenFilter, setIsModalOpenFilter] = useState(false);
  const [showStatsModal, setShowStatsModal] = useState(false);
  const [statsData, setStatsData] = useState(null);
  const [statsLoading, setStatsLoading] = useState(false);
  const [statsError, setStatsError] = useState("");

  const handleReset = () => {
    setFilterData(defaultFilterData);
    fetchBulkSmsData(1, defaultFilterData);
  };

  const openModalFilter = () => {
    setIsModalOpenFilter(true);
  };

  const closeModalFilter = () => {
    setIsModalOpenFilter(false);
  };

  useEffect(() => {
    fetchBulkSmsData(1, filterData);
  }, []);

  const fetchDashboardData = () => {
    const endDate = formatDateToYYYYMMDD(new Date());
    const startDate1 = new Date(new Date().setDate(new Date().getDate() - 90));
    const finalStartDate = formatDateToYYYYMMDD(startDate1);

    const requestBody = {
      startDate: finalStartDate,
      endDate: endDate,
      username: loggedInUserName,
    };

    axiosPostApi(apiList.DASHBOARD_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.respCode === "00") {
          dispatch(setBalance(response?.data?.data?.balanceDetails));
        } else {
          // Handle error case here if necessary
        }
      })
      .catch((error) => {
        console.error("Error fetching SMS overview data", error);
      });
  };

  const fetchBulkSmsData = async (currentPage, filters = filterData) => {
    try {
      const requestBody = {
        username: loggedInUserName,
        sendorId: filters.sendorId || "",
        templateId: filters.templateId || "",
        status: filters.status || [],
        fromDate: filters.fromDate ? formatDate(filters.fromDate) : "",
        toDate: filters.toDate ? formatDate(filters.toDate) : "",
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_BULK_REPORT_DATA}?&pageSize=${pageSize}&pageNo=${currentPage}`,
        requestBody
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetails(response?.data?.pageDetails);

        const modifiedData = modifyStructure(response?.data?.data);

        setSmsData(modifiedData);
        fetchDashboardData();
        if (modifiedData?.length === 0) {
          setNoData(true);
        } else {
          setNoData(false);
        }
      } else {
        setNoData(true);
        setSmsData([]);

        if (response?.data?.data !== null) {
          CustomAlert({
            title: "No Data",
            text: "No data available for the specified criteria.",
            icon: "info",
            confirmButtonText: "Okay",
          });
        }
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      }).then((result) => {
        if (result.isConfirmed) {
          sessionStorage.clear();
          window.location.href = "/";
        }
      });
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const csvHeader = [
    { label: "Mobile No", key: "mobileNo" },
    { label: "Template", key: "sms" },
    { label: "Send Txn ID", key: "sendTxnId" },
    { label: "Status", key: "status" },
    { label: "SMS Response", key: "smsResponse" },
    { label: "Response Date", key: "responseDate" },
  ];

  const statusMap = {
    C: "Complete",
    F: "Failed",
    P: "Pending",
  };

  const fetchByFilePath = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("filePath", rowData?.filePath);
      const response = await axiosPostApi(apiList.FETCH_BY_FILE_PATH, formData);
      if (response?.status === 200 && response?.data?.respCode === "00") {
        const data = response?.data?.data?.records || [];

        const transformedData = data?.map((item) => ({
          ...item,
          status: statusMap[item.status] || item.status,
        }));

        downloadExcel(transformedData, csvHeader, "BulkMessage.xlsx");

        setLoading(false);
      } else if (response?.data?.respCode === "05") {
        setLoading(false);
        CustomAlert({
          title: "Info",
          text:
            response?.data?.message || "Invalid credentials. Please try again!",
          icon: "info",
          confirmButtonText: "Retry",
        });
      } else {
        CustomAlert({
          title: "Data Fetch Error",
          text:
            response?.data?.message ||
            "No data available for the specified criteria.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: `There was an error: ${error?.message}`,
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (rowData?.filePath) {
      if (rowData?.status === "COMPLETED") {
        fetchByFilePath();
      } else {
        Swal.fire({
          title: "No Record Found",
          icon: "info",
          confirmButtonText: "ok",
        });
      }
    }
  }, [rowData]);

  // const modifyStructure = (response) => {

  //   const modified = response?.map((user, index) => ({
  //     ...user,
  //     id: index + 1,
  //     uploadedDate: user?.uploadedDate
  //       ? format(new Date(user?.uploadedDate), "dd-MM-yyyy HH:mm:ss")
  //       : "",
  //     updatedDate: user?.updatedDate
  //       ? format(new Date(user?.updatedDate), "dd-MM-yyyy HH:mm:ss")
  //       : "",
  //   }));
  //   return modified;
  // };

  const modifyStructure = (response) => {
    const modified = response?.map((user, index) => {
      const uploadedDateParsed = user?.uploadedDate
        ? parse(user.uploadedDate, "dd-MM-yyyy HH:mm:ss", new Date())
        : null;

      const updatedDateParsed = user?.updatedDate
        ? parse(user.updatedDate, "dd-MM-yyyy HH:mm:ss", new Date())
        : null;

      return {
        ...user,
        id: index + 1,
        bulkFileId: user?.id,
        uploadedDate: uploadedDateParsed
          ? format(uploadedDateParsed, "dd-MM-yyyy HH:mm:ss")
          : "",
        updatedDate: updatedDateParsed
          ? format(updatedDateParsed, "dd-MM-yyyy HH:mm:ss")
          : "",
      };
    });

    return modified;
  };

  const handleAuthorization = (authData) => {
    const loggedInUserName = sessionStorage.getItem("username");
    const requestBody = {
      ...authData,
      username: loggedInUserName,
      status: "2",
    };

    axiosPostApi(apiList.AUTH_USER_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.respCode === "00") {
          toast.success("User Authorized successfully!");
          fetchBulkSmsData(1);
        } else {
          CustomAlert({
            title: "Failed to Authorized user",
            text:
              response.data?.message ||
              "Invalid credentials. Please try again!",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      })
      .catch((error) => {
        console.error("Error Authorized user", error);
        toast.error("Failed to Authorized user.");
      });
  };

  const userHeaders = [
    "Sendor Id",
    "Entity Id",
    "Template Id",
    "Req Date",
    "Resp Date",
    "File Name",
    "Upload Status",
    // "Channel",
    "Action",
  ];

  const userHeaderToKeyMap = {
    "Sendor Id": "sendorId",
    "Entity Id": "entityId",
    "Template Id": "templateId",
    "Req Date": "uploadedDate",
    "Resp Date": "updatedDate",
    "File Name": "fileName",
    "Upload Status": "status",
    // Channel: "channel",
    "Action": "download",
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditData({});
    setModalAction("");
  };

  const fetchBulkStats = async (bulkFileId) => {
    try {
      setStatsLoading(true);
      setStatsError("");
      const response = await axiosGetApi(
        `${apiList.BULK_STATS}?bulkFileId=${bulkFileId}`
      );
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setStatsData(response?.data?.data?.stats || {});
      } else {
        setStatsData({});
        setStatsError(
          response?.data?.message || "Unable to fetch campaign statistics."
        );
      }
    } catch (error) {
      console.error("Error fetching campaign statistics", error);
      setStatsData({});
      setStatsError("Unable to fetch campaign statistics. Please try again.");
    } finally {
      setStatsLoading(false);
    }
  };

  const handleCloseStatsModal = () => {
    setShowStatsModal(false);
    setStatsData(null);
    setStatsError("");
  };

  const handleUser = (data, actionType = "view") => {
    setModalAction(actionType);
    if (actionType === "add") {
      setEditData({});
      setShowModal(true);
    } else if (actionType === "showStats") {
      setEditData(data);
      setShowStatsModal(true);      
      fetchBulkStats(data?.bulkFileId);
    } else {
      let smsDataL = smsData?.find((item) => item?.id === data?.id);
      if (smsDataL) {
        setEditData(smsDataL);
        setShowModal(true);
      }
    }
  };

  const pageSizeCount = pageDetails === null ? 0 : pageDetails.pageSize;
  const totalRecord = pageDetails === null ? 0 : pageDetails.totalRecords;

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <>
          <MasterTable
            loading={loading}
            pageDetails={pageDetails}
            headers={userHeaders}
            data={smsData}
            handleAction={handleUser}
            filterFields={["templateId"]}
            entityType="Bulk Upload"
            headerToKeyMap={userHeaderToKeyMap}
            noData={noData}
            handleAuth={handleAuthorization}
            currentPage={currentPage}
            pageSize={pageSizeCount}
            totalRecord={totalRecord}
            fetchNextData={fetchBulkSmsData}
            setCurrentPage={setCurrentPage}
            setRowData={setRowData}
            openModalFilter={openModalFilter}
            handleReset={handleReset}
            filterData={filterData}
            fetchData={() => {}}
          />
          <BulkMessageModal
            show={showModal}
            handleClose={handleCloseModal}
            callApi={() => fetchBulkSmsData(1)}
          />
          <StatsModal
            show={showStatsModal}
            handleClose={handleCloseStatsModal}
            loading={statsLoading}
            stats={statsData}
            errorMessage={statsError}
            bulkFileId={editData?.bulkFileId}
          />
          {isModalOpenFilter ? (
            <BulkFilterModal
              show={isModalOpenFilter}
              handleClose={closeModalFilter}
              setSmsData={setSmsData}
              setPageDetails={setPageDetails}
              setNoData={setNoData}
              currentPage={currentPage}
              pageSize={pageSize}
              filterData={filterData}
              setFilterData={setFilterData}
              handleReset={handleReset}
            />
          ) : null}
        </>
      )}
    </div>
  );
};

export default BulkReport;
